import React, { Component } from 'react'
import { FormControl } from 'react-bootstrap'

export default class ProvincesDropdown extends Component {
  constructor(props) {
    super(props)

    if (this.props.defaultValue) {
      this.state = {
        selectedValue: this.props.defaultValue
      }
    } else {
      this.state = {
        selectedValue: null
      }
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.defaultValue) {
      this.setState({
        selectedValue: newProps.defaultValue
      });
    }
  }

  onChange(e) {

    this.setState({
      selectedValue: e.target.value
    })

    if (this.props.onChange) {
      this.props.onChange(e)
    }
  }

  render() {
    return (
      <FormControl componentClass="select" placeholder="Province" id={ this.props.id } onChange={ this.onChange.bind(this) } value={ this.state.selectedValue } >
        <option value="AB">Alberta</option>
        <option value="BC">British Columbia</option>
        <option value="MB">Manitoba</option>
        <option value="NB">New Brunswick</option>
        <option value="NL">Newfoundland and Labrador</option>
        <option value="NS">Nova Scotia</option>
        <option value="ON">Ontario</option>
        <option value="PE">Prince Edward Island</option>
        <option value="QC">Quebec</option>
        <option value="SK">Saskatchewan</option>
        <option value="NT">Northwest Territories</option>
        <option value="NU">Nunavut</option>
        <option value="YT">Yukon</option>
      </FormControl>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/provincesdropdown.js